<template>
  <div :class="classObj" class="app-wrapper">
    <navbar/>
    <sidebar :reload="reload" class="sidebar-container"/>
      <div class="main-container">
        <app-main v-if="isRouterAlive"/>
      </div>
  </div>
</template>

<script>
import { Sidebar, Navbar, AppMain } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
export default {
  name: "Layout",
  components: {
    Sidebar,
    Navbar,
    AppMain
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  mixins: [],
  computed: {
    classObj() {
      return {
        hideSidebar: true
      };
    }
  },
  methods: {
    // reload page when click
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
// @import "~@/styles/mixin.scss";
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue